import type { LeadCloudFileType } from '@econtractor/types';

export const previewTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'bmp', 'svg'];

export const parseCloudFiles = (raw?: string | LeadCloudFileType[] | null): LeadCloudFileType[] => {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.filter((item) => item?.publicUrl && item?.fileName);

    try {
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((item) => item?.publicUrl && item?.fileName);
    } catch {
        return [];
    }
};

export const stringifyCloudFiles = (files: LeadCloudFileType[]): string => JSON.stringify(files);

export const getFileExtension = (fileName: string): string => fileName.split('.').pop()?.toLowerCase() || '';

export const isPreviewImage = (fileName: string): boolean => previewTypes.includes(getFileExtension(fileName));

export const toStoredCloudFile = (file: LeadCloudFileType): LeadCloudFileType => ({
    fileName: file.fileName,
    contentType: file.contentType,
    fileSize: file.fileSize,
    storageKey: file.storageKey,
    publicUrl: file.publicUrl,
});
